import { cloneElement, FC } from 'react';
import classnames from 'classnames';

import { CustomChipProps } from '@hh.ru/magritte-ui-chips/types';
import { Text } from '@hh.ru/magritte-ui-typography';

import styles from './chips.less';

type ChipContentProps = Pick<
    CustomChipProps,
    'addon' | 'hideLabel' | 'aria-label' | 'postfix' | 'onDelete' | 'children' | 'size' | 'mode'
>;

const ChipContent: FC<ChipContentProps> = ({
    addon,
    'aria-label': ariaLabel,
    hideLabel,
    onDelete,
    postfix,
    children,
    size = 'medium',
    mode = 'primary',
}) => {
    const showLabel = !hideLabel && !!children;
    const typographyForPrimary = size === 'small' ? 'subtitle-2-semibold' : 'subtitle-1-semibold';
    const typography = mode === 'secondary' ? 'label-3-regular' : typographyForPrimary;
    return (
        <span
            className={classnames(styles.content, {
                [styles.contentDeletable]: !!onDelete,
            })}
        >
            {addon && (
                <span className={styles.addon}>
                    {cloneElement(addon, {
                        'data-qa': 'chip-addon',
                        'aria-label': ariaLabel,
                        'aria-hidden': showLabel,
                    })}
                </span>
            )}
            {showLabel && (
                <span className={styles.labelContainer}>
                    <span className={styles.label}>
                        <Text Element="span" typography={typography}>
                            {children}
                        </Text>
                    </span>
                    {postfix && (
                        <span className={styles.postfixWrapper}>
                            <Text Element="span" typography={typography}>
                                <span className={styles.postfix}>{postfix}</span>
                            </Text>
                        </span>
                    )}
                </span>
            )}
        </span>
    );
};

export default ChipContent;
